<template>
  <div class="payrollRequest">
    <van-form label-width="120px">
      <div class="title">{{ $t.payrollRequest.title }}</div>

      <van-field
        v-model="form.CategoryName"
        is-link
        readonly
        required
        :label="$t.payrollRequest.costCate"
        :placeholder="$t.meta.select"
        @click="pickerShow('showCategoryPicker')"
      />

      <div class="custom-date">
        <div class="date-btn1">
          <div class="date-require">*</div>
          {{ $t.payrollRequest.startDate }}
        </div>
        <div class="date-btn2" @click="showBeginTimeDate">
          <span v-if="form.BeginDate" class="value">{{ form.BeginDate }}</span>
          <span v-else class="placeholder"
            ><span v-if="isEdit">{{ $t.meta.select }}</span></span
          >
        </div>
      </div>

      <div class="custom-date">
        <div class="date-btn1">
          <div class="date-require">*</div>
          {{ $t.payrollRequest.endDate }}
        </div>
        <div class="date-btn2" @click="showEndTimeDate">
          <span v-if="form.EndDate" class="value">{{ form.EndDate }}</span>
          <span v-else class="placeholder"
            ><span v-if="isEdit">{{ $t.meta.select }}</span></span
          >
        </div>
      </div>

      <div class="custom-date">
        <div class="date-btn1">
          <div class="date-require">*</div>
          {{ $t.payrollRequest.time }}
        </div>
        <div class="date-btn2" @click="showTimeDate">
          <span v-if="form.Time" class="value">{{ form.Time }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        v-model="form.PaymentAddress"
        :label="$t.payrollRequest.paymentAddress"
        type="textarea"
        rows="3"
        required
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.PaymentInstructions"
        :label="$t.payrollRequest.instructions"
        type="textarea"
        rows="3"
        required
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.CurrencySn"
        :label="$t.meta.currency"
        @click="pickerShow('showCurrencyPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
      />

      <van-field
        v-model="form.FeeAmount"
        :label="$t.payrollRequest.feeAmount"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
        required
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <van-field
        v-model="form.ExpenseVoucherNumber"
        :label="$t.payrollRequest.voucherNumber"
        required
        :placeholder="!isEdit ? '' : $t.meta.input"
        :disabled="!isEdit ? true : false"
      />

      <div class="multi-table" v-if="form.VoucherFileList">
        <van-field
          name="stepper"
          :label="$t.payrollRequest.requestReceipt"
          required
        >
          <template #input>
            <van-stepper
              :min="0"
              :value="form.VoucherFileList.length"
              @minus="handleVoucherDel"
              @plus="handleVoucherAdd"
              :disable-input="true"
              :disabled="!isEdit ? true : false"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.VoucherFileList" :key="index">
          <div class="multi-table-header" v-if="isEdit">
            <div class="multi-table-title"></div>
            <div
              class="multi-table-btn"
              @click="handleVoucherDelByIndex(index)"
            >
              <van-icon name="close" />
            </div>
          </div>
          <van-field :label="'No.' + (index + 1)">
            <template #input>
              <van-button
                @click="imagePreview(imgUrlFilter(item.VoucherFile))"
                type="primary"
                size="small"
                style="vertical-align: top; margin: 10px 30px 10px 0px"
                v-if="item.VoucherFile"
                >{{ $t.meta.view }}</van-button
              >
              <van-uploader
                :after-read="afterRead"
                @click-upload="uploaderClick(index)"
              >
                <van-image
                  :src="item.VoucherFile && imgUrlFilter(item.VoucherFile)"
                  width="50"
                  height="50"
                  fit="contain"
                  style="vertical-align: top"
                  v-if="item.VoucherFile"
                ></van-image>
                <van-button
                  type="info"
                  size="small"
                  style="vertical-align: top; margin: 10px 30px 10px 0px"
                  v-else
                  >{{ $t.meta.upload }}</van-button
                >
              </van-uploader>
            </template>
          </van-field>
        </div>
      </div>

      <van-field
        clickable
        readonly
        :value="form.CollaboratorUserListText"
        :label="$t.payrollRequest.userList"
        type="textarea"
        rows="3"
        :placeholder="!isEdit ? '' : $t.meta.select"
        @click="onShowEmit('showPayrollRequestUser', form.CollaboratorUserList)"
      />

      <div class="payrollRequest-radio">
        <div class="radio-label">{{ $t.payrollRequest.isBudget }}</div>
        <van-radio-group
          v-model="form.IsBudgetedExpenditure"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.meta.yes }}</van-radio>
          <van-radio :name="0">{{ $t.meta.no }}</van-radio>
        </van-radio-group>
      </div>

      <div class="payrollRequest-radio">
        <div class="radio-label">{{ $t.payrollRequest.recipient }}</div>
        <van-radio-group
          v-model="form.PaymentMethod"
          direction="horizontal"
          :disabled="!isEdit ? true : false"
        >
          <van-radio :name="1">{{ $t.payrollRequest.mState1 }}</van-radio>
          <van-radio :name="2">{{ $t.payrollRequest.mState2 }}</van-radio>
          <van-radio :name="3">{{ $t.payrollRequest.mState3 }}</van-radio>
        </van-radio-group>
      </div>

      <div v-if="form.PaymentMethod == 2">
        <van-field
          :label="$t.payrollRequest.qrcode"
          v-if="form.ElectronicWalletQrCode"
        >
          <template #input>
            <van-image
              width="80"
              height="80"
              fit="contain"
              :src="imgUrlFilter(form.ElectronicWalletQrCode)"
              @click="imagePreview(imgUrlFilter(form.ElectronicWalletQrCode))"
            />
          </template>
        </van-field>
        <div v-else class="empty-text">{{ $t.meta.noData }}</div>
      </div>

      <div v-if="form.PaymentMethod == 3">
        <div v-if="form.BankAccount">
          <div class="title">{{ $t.payrollRequest.myBankAccount }}</div>
          <van-field
            v-model="form.BankName"
            :label="$t.payrollRequest.bankInfo"
            readonly
          />
          <van-field
            v-model="form.BankAccount"
            :label="$t.payrollRequest.bankAccount"
            readonly
          />
          <van-field
            v-model="form.BankAccountName"
            :label="$t.payrollRequest.bankName"
            readonly
          />
        </div>
        <div v-else class="empty-text">{{ $t.meta.noData }}</div>
      </div>

      <div
        class="title"
        v-if="form.ApprovalProcessList && form.ApprovalProcessList.length > 0"
      >
        {{ $t.payrollRequest.processList }}
      </div>
      <van-steps
        direction="vertical"
        active-icon="wap-nav"
        active-color="#323233"
        :active="form.ApprovalProcessList.length"
        v-if="form.ApprovalProcessList && form.ApprovalProcessList.length > 0"
      >
        <van-step
          v-for="(process, index) in form.ApprovalProcessList"
          :key="index"
        >
          <div style="margin-bottom: 5px">
            {{ $t.payrollRequest.position }} : {{ process.Position }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollRequest.username }} : {{ process.UserName }}
          </div>
          <div>
            {{ $t.payrollRequest.approvalState }} :
            <span v-if="process.ApprovalState == 0">{{
              $t.payrollRequest.aState1
            }}</span>
            <span v-if="process.ApprovalState == 1">{{
              $t.payrollRequest.aState2
            }}</span>
            <span v-if="process.ApprovalState == 2">{{
              $t.payrollRequest.aState3
            }}</span>
            <span v-if="process.ApprovalState == 3">{{
              $t.payrollRequest.aState4
            }}</span>
          </div>
        </van-step>
      </van-steps>

      <div
        class="title"
        v-if="
          form.ActualApprovalProcessList &&
          form.ActualApprovalProcessList.length > 0
        "
      >
        {{ $t.payrollRequest.approvalResult }}
      </div>
      <van-steps
        direction="vertical"
        active-icon="wap-nav"
        active-color="#323233"
        :active="form.ActualApprovalProcessList.length"
        v-if="
          form.ActualApprovalProcessList &&
          form.ActualApprovalProcessList.length > 0
        "
      >
        <van-step
          v-for="(result, index) in form.ActualApprovalProcessList"
          :key="index"
        >
          <div style="margin-bottom: 5px">
            {{ $t.payrollRequest.position }} : {{ result.Position }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollRequest.approvalUser }} : {{ result.UserName }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollRequest.opinions }} : {{ result.ApprovalOpinions }}
          </div>
          <div>{{ $t.payrollRequest.auditTime }} : {{ result.AuditTime }}</div>
        </van-step>
      </van-steps>

      <div v-if="form.IsPageShowAuditFunction">
        <div class="title">{{ $t.payrollRequest.approvalOperate }}</div>

        <van-field
          v-model="form.ApprovalOpinions"
          :label="$t.payrollRequest.opinions"
          :placeholder="!isEdit ? '' : $t.meta.input"
          type="textarea"
          rows="3"
          required
        />

        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            @click="onApproval(2)"
            style="margin-top: 10px"
            >{{ $t.payrollRequest.agree }}</van-button
          >
          <van-button
            round
            block
            type="danger"
            @click="onApproval(3)"
            style="margin-top: 10px"
            >{{ $t.payrollRequest.disagree }}</van-button
          >
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit" v-if="isEdit">
          <span v-if="pageType == 'new'">{{ $t.meta.submit }}</span>
          <span v-else>
            <span v-if="form.ApprovalState == 2 || form.ApprovalState == 3">{{
              $t.payrollRequest.resubmit
            }}</span>
            <span v-else>{{ $t.payrollRequest.saveChange }}</span>
          </span></van-button
        >
        <van-button
          round
          block
          type="danger"
          style="margin-top: 10px"
          v-if="pageType == 'edit' && form.ApprovalState != 2"
          @click="onCancel"
          >{{ $t.payrollRequest.cancelApply }}</van-button
        >
      </div>
    </van-form>

    <van-popup v-model="showCategoryPicker" round position="bottom">
      <van-cascader
        :value="form.Category"
        :title="$t.payrollRequest.costCate"
        :placeholder="$t.meta.select"
        active-color="#1e90ff"
        :options="categoryOptions"
        :field-names="fieldNames"
        @finish="categoryConfirm"
        @close="showCategoryPicker = false"
      />
    </van-popup>

    <van-popup v-model="showBeginTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter1"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 1)"
        @cancel="showBeginTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter1"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 2)"
        @cancel="showEndTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t.payrollRequest.time"
        :formatter="formatter2"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 3)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
      />
    </van-popup>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="currencyConfirm"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <check-list
      event="showPayrollRequestUser"
      :options="userOptions"
      :value="checkListValues"
      @onSelect="onSelectUser"
    ></check-list>
  </div>
</template>
<script>
import Vue from "vue";
import CheckList from "@components/checkList/CheckList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
  Collapse,
  CollapseItem,
  Step,
  Steps,
  Cascader,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Collapse)
  .use(CollapseItem)
  .use(Step)
  .use(Steps)
  .use(Cascader);

export default {
  name: "payrollRequest",
  components: {
    CheckList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      pageType: "new",
      isEdit: false,
      OERId: "",
      form: {
        ApprovalState: "",
        CategoryName: "",
        CategoryId: "",
        BeginDate: "",
        EndDate: "",
        Time: "",
        PaymentAddress: "",
        PaymentInstructions: "",
        CurrencySn: "",
        SCId: "",
        FeeAmount: "",
        ExpenseVoucherNumber: "",
        IsBudgetedExpenditure: 1,
        PaymentMethod: 1,
        VoucherFileList: [],
        ApprovalProcessList: [],
        ActualApprovalProcessList: [],
        CollaboratorUserListText: "",
        CollaboratorUserList: [],
        IsPageShowAuditFunction: 0, //页面是否显示审核功能
        ApprovalOpinions: "", //	批复意见
      },
      currencyList: [],
      categoryOptions: [],
      fieldNames: {
        text: "CategoryName",
        value: "ECId",
        children: "ExpenseSubCategory",
      },
      userOptions: [],
      checkListValues: [],
      approvalProcessList: [],
      //日期
      selectDate: new Date(),
      showBeginTimePicker: false,
      showEndTimePicker: false,
      showTimePicker: false,
      currentDate: "",
      //picker
      showCategoryPicker: false,
      showCurrencyPicker: false,
      filesIndex: 0,
    };
  },
  created() {
    const { Type, OERId } = this.$route.query;
    this.pageType = Type;
    if (this.pageType == "new") {
      this.isEdit = true;
      this.loadInfo("new");
    }
    if (this.pageType == "detail") {
      this.OERId = OERId;
      this.isEdit = false;
      this.getInfo("detail");
    }
    if (this.pageType == "edit") {
      this.OERId = OERId;
      this.isEdit = true;
      this.getInfo("edit");
    }
  },
  methods: {
    handleVoucherDelByIndex(index) {
      if (this.form.VoucherFileList.length > 0) {
        this.form.VoucherFileList.splice(index, 1);
      }
    },
    handleVoucherDel() {
      if (this.form.VoucherFileList.length > 0) {
        this.form.VoucherFileList.pop();
      }
    },
    handleVoucherAdd() {
      this.form.VoucherFileList.push({
        VoucherFile: "",
      });
    },
    showBeginTimeDate() {
      if (!this.isEdit) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showBeginTimePicker = true;
    },
    showEndTimeDate() {
      if (!this.isEdit) {
        return;
      }
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndTimePicker = true;
    },
    showTimeDate() {
      if (!this.isEdit) {
        return;
      }
      var time = new Date();
      time.setTime(time.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = time;
      this.showTimePicker = true;
    },
    formatter1(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    formatter2(type, val) {
      if (type === "hour") {
        return val;
      }
      if (type === "minute") {
        return val;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == 1) {
        this.form.BeginDate = formatDate(date);
        this.showBeginTimePicker = false;
      }
      if (type == 2) {
        this.form.EndDate = formatDate(date);
        this.showEndTimePicker = false;
      }
      if (type == 3) {
        this.form.Time = date;
        this.showTimePicker = false;
      }
    },
    categoryConfirm(e) {
      this.form.CategoryName = e.selectedOptions
        .map((option) => option.CategoryName)
        .join(" / ");
      this.form.CategoryId = e.value;
      this.showCategoryPicker = false;
    },
    currencyConfirm(e) {
      if (!e) {
        return;
      }
      this.form.CurrencySn = e.text;
      this.form.SCId = e.value;
      this.showCurrencyPicker = false;
    },
    pickerShow(pickerName) {
      if (!this.isEdit) {
        return;
      }
      this[pickerName] = true;
    },
    onShowEmit(emit, items) {
      if (!this.isEdit) {
        return;
      }
      var values = [];
      if (items && items.length > 0) {
        for (var id of items) {
          values.push(id.toString());
        }
      }
      this.checkListValues = values;
      this.$bus.$emit(emit, true);
      setTimeout(() => {
        this.$bus.$emit(emit, true);
      }, 100);
    },
    onSelectUser(e) {
      var users = [];
      this.form.CollaboratorUserListText = e
        .map((option) => option.text)
        .join(" , ");
      for (var user of e) {
        if (user.value) {
          users.push(user.value);
        }
      }
      this.form.CollaboratorUserList = users;
      this.$forceUpdate();
    },
    loadInfo(type) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.financialManagement
          .loadOperatingExpenseRequestInfo()
          .then((res) => {
            this.applyData(res.data, type);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
          });
      });
    },
    getInfo(type) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = { OERId: this.OERId };
        this.$api.financialManagement
          .getOperatingExpenseRequestDetail(param)
          .then((res) => {
            this.applyData(res.data, type);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(
              this.$commonEnv.actionType.showDialog,
              {
                msg: error.message,
              }
            );
          });
      });
    },
    applyData(data, type) {
      var currencyList = [];
      data.CurrencyList.forEach((item) => {
        let data = {
          text: item.CurrencySn,
          value: item.SCId,
        };
        currencyList.push(data);
      });
      this.currencyList = currencyList;

      this.categoryOptions = this.formatCategory(data.ExpenseCategoryList);

      var userOptions = [];
      data.UserList.forEach((item) => {
        let data = {
          text: item.UserName,
          value: item.UserId,
        };
        userOptions.push(data);
      });
      this.userOptions = userOptions;

      this.form.ElectronicWalletQrCode = data.ElectronicWalletQrCode;
      this.form.BankAccountName = data.BankAccountName;
      this.form.BankAccount = data.BankAccount;
      this.form.BankName = data.BankName;

      this.form.IsPageShowAuditFunction = data.IsPageShowAuditFunction; //页面是否显示审核功能
      this.form.ApprovalProcessList = data.ApprovalProcessList; //	审批流程列表
      this.form.ActualApprovalProcessList = data.ActualApprovalProcessList; //	审批结果列表

      if (type == "detail" || type == "edit") {
        this.OERId = data.OERId;
        this.form.ApprovalState = data.ApprovalState;
        //费用类目
        this.form.CategoryId = data.CategoryIdList[2];
        var categories = [];
        for (var category1 of data.ExpenseCategoryList) {
          if (category1.ECId == data.CategoryIdList[0]) {
            categories.push(category1.CategoryName);
          }
          for (var category2 of category1.ExpenseSubCategory) {
            if (!data.CategoryIdList[1]) {
              break;
            }
            if (category2.ECId == data.CategoryIdList[1]) {
              categories.push(category2.CategoryName);
            }
            for (var category3 of category2.ExpenseSubCategory) {
              if (!data.CategoryIdList[2]) {
                break;
              }
              if (category3.ECId == data.CategoryIdList[2]) {
                categories.push(category3.CategoryName);
              }
            }
          }
        }
        if (categories.length > 0) {
          this.form.CategoryName = categories.join(" / ");
        }

        this.form.BeginDate = data.BeginDate;
        this.form.EndDate = data.EndDate;
        this.form.Time = data.Time;
        this.form.PaymentAddress = data.PaymentAddress;
        this.form.PaymentInstructions = data.PaymentInstructions;

        //货币
        this.form.SCId = data.SCId.toString();
        var currency = this.currencyList.find((c) => c.value == this.form.SCId);
        if (currency) {
          this.form.CurrencySn = currency.text;
        }

        this.form.FeeAmount = data.FeeAmount;
        this.form.ExpenseVoucherNumber = data.ExpenseVoucherNumber;
        this.form.PaymentSystemCode = data.PaymentSystemCode;
        this.form.IsBudgetedExpenditure = data.IsBudgetedExpenditure;
        this.form.PaymentMethod = data.PaymentMethod;
        this.form.VoucherFileList = data.PaymentRequestVoucherList;

        //协同人员
        if (data.CollaboratorUserList) {
          this.form.CollaboratorUserList = data.CollaboratorUserList;
          var users = [];
          for (var userId of data.CollaboratorUserList) {
            var user = this.userOptions.find((c) => c.value == userId);
            if (user) {
              users.push(user);
            }
          }
          if (users.length > 0) {
            this.form.CollaboratorUserListText = users
              .map((option) => option.text)
              .join(" , ");
          }
        }
      }
    },
    formatCategory(data) {
      for (var c1 in data) {
        var item1 = data[c1];
        for (var c2 in item1.ExpenseSubCategory) {
          var item2 = item1.ExpenseSubCategory[c2];
          if (item2.ParentId == item1.ECId) {
            for (var c3 in item2.ExpenseSubCategory) {
              var item3 = item2.ExpenseSubCategory[c3];
              delete item3.ExpenseSubCategory;
            }
          }
        }
      }
      return data;
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        OERId: this.OERId ? this.OERId : "",
        SubCategoryId: this.form.CategoryId,
        BeginDate: this.form.BeginDate,
        EndDate: this.form.EndDate,
        Time: this.form.Time,
        PaymentAddress: this.form.PaymentAddress,
        PaymentInstructions: this.form.PaymentInstructions,
        SCId: this.form.SCId,
        FeeAmount: this.form.FeeAmount,
        ExpenseVoucherNumber: this.form.ExpenseVoucherNumber,
        IsBudgetedExpenditure: this.form.IsBudgetedExpenditure,
        PaymentMethod: this.form.PaymentMethod,
        VoucherFileList: this.form.VoucherFileList,
        CollaboratorUserList: this.form.CollaboratorUserList,
      };
      var request = null;
      if (this.pageType == "edit") {
        request =
          this.$api.financialManagement.editOperatingExpenseRequest(param);
      } else {
        request =
          this.$api.financialManagement.addOperatingExpenseRequest(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onCancel() {
      this.$commonMethod.showLoading();
      var param = {
        OERId: this.OERId,
      };
      this.$api.financialManagement
        .cancelOperatingExpenseRequest(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onApproval(state) {
      this.$commonMethod.showLoading();
      var param = {
        OERId: this.OERId,
        ApprovalState: state,
        ApprovalOpinions: this.form.ApprovalOpinions,
      };
      this.$api.financialManagement
        .addPayrollRequestApprovalProcessByOERId(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    uploaderClick(index) {
      this.filesIndex = index;
    },
    afterRead(file) {
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.VoucherFileList[this.filesIndex].VoucherFile = res.data;
        })
        .catch(() => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.payrollRequest {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-steps {
    background: transparent;
  }
  .collapse-title {
    color: #646566;
  }
  ::v-deep .van-step__line {
    display: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px 16px;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
  .payrollRequest-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 33%;
      display: inline-block;
      margin-right: 5%;
      font-size: 14px;
      color: #646566;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 62%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .subTotal {
    padding: 10px 16px;
    border-bottom: 1px solid #ebedf0;
    color: #646566;
    .subTotal-label {
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #2c88c1;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .empty-text {
    text-align: center;
    padding: 20px;
    font-size: 14px;
    color: #969799;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .tool-button {
      align-items: center;
    }
  }
}
</style>
